import React, { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import ListItem from "@material-ui/core/ListItem";
import {
  ListItemText,
  List,
  ListItemAvatar,
  ListItemSecondaryAction,
  IconButton,
  Tooltip,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useDropzone } from "react-dropzone";
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";
import DeleteIcon from "@material-ui/icons/Delete";

const useStyles = makeStyles({
  dropzone: {
    padding: "2rem 2rem 1rem",
    backgroundColor: "#fff",
    border: "1px dashed #dee2e6",
    borderRadius: ".375rem",
    textAlign: "center",
    color: "#8898aa",
    transition: "all .15s ease",
    order: -1,
    cursor: "pointer",
    zIndex: 999,
  },
});

const FilesList = ({ files, removeFileFromList, disabled }) => {
  return (
    <List>
      {files?.map((file, index) => (
        <ListItem
          key={index}
          style={{ display: "flex", alignItems: "center" }}
        >
          <ListItemAvatar>
            <InsertDriveFileIcon style={{ width: 30, height: 45 }} />
          </ListItemAvatar>
          <ListItemText
            primary={file.name}
            primaryTypographyProps={{ variant: "h4", component: "h4" }}
            secondary={`${file.size / 1000} Kb`}
            secondaryTypographyProps={{ variant: "h5", component: "h5" }}
          />
          <ListItemSecondaryAction>
            <Tooltip title="Remover arquivo" aria-label="delete">
              <IconButton
                aria-label="delete"
                onClick={() => removeFileFromList(index)}
                disabled={disabled}
              >
                <DeleteIcon
                  color={disabled ? "inherit" : "primary"}
                  style={{ width: 25, height: 25 }}
                />
              </IconButton>
            </Tooltip>
          </ListItemSecondaryAction>
        </ListItem>
      ))}
    </List>
  )
}

function UploadFileMultiple({ multiple, accept, message, validator, onChangeFiles, disabled }) {
  const classes = useStyles();
  const [files, setFiles] = useState([]);

  const onDrop = React.useCallback(acceptedFiles => {
    setFiles(prev => [...prev, ...acceptedFiles]);
  }, []);

  const { getRootProps, getInputProps } = useDropzone({
    multiple,
    accept,
    validator,
    onDrop
  });

  useEffect(() => {
    onChangeFiles(files);
  }, [files, onChangeFiles]);

  const removeFileFromList = useCallback(
    (position) => {
      const filesToRemove = files

      filesToRemove.splice(position, 1);

      setFiles([...filesToRemove]);
    },
    [files]
  );

  return (
    <>
      <div {...getRootProps({ className: classes.dropzone })}>
        <input {...getInputProps()} disabled={disabled} />
        <p>{message}</p>
      </div>
      {files.length > 0 ? (
        <FilesList files={files} removeFileFromList={removeFileFromList} disabled={disabled} />
      ) : null}
    </>
  );
}

UploadFileMultiple.propTypes = {
  /**
   * Define se o upload será de multiplos arquivos. Default false
   */
  multiple: PropTypes.bool,
  /**
   * Extensões/tipos de arquivo que serão aceitos. Default null, que aceitará qualquer extensão ou tipo.
   */
  accept: PropTypes.string,
  /**
   * Mensagem que será exibida dentro do box de upload.
   */
  message: PropTypes.string,
  /**
   * Desabilita o box e o botão de remover arquivo
   */
  disabled: PropTypes.bool,
};

UploadFileMultiple.defaultProps = {
  accept: null,
  message: "Selecione um arquivo ou arraste aqui",
};

export default UploadFileMultiple;
